import ErrorPage from "./lib/ErrorPage";
export * from "./lib/ErrorPage";
export default ErrorPage;
